export const DEFAULT_MINIMUM_BALANCE = 20;

/**
 * Determine if JWO is enabled from per-site public config.
 * @param {Object|null} sitePublicConfig - response from GET /config/public/{siteId}
 * @returns {boolean}
 */
export function isSiteFrictionlessFromConfig(sitePublicConfig) {
  return Boolean(sitePublicConfig?.jwo?.enabled);
}

/**
 * Build the JWO portion of the per-site config payload.
 * @param {boolean} enabled
 * @param {number} minimumBalance
 * @returns {{ jwo: { enabled: boolean, minimum_balance: number } }}
 */
export function prepareJwoSiteConfigPayload(enabled, minimumBalance = DEFAULT_MINIMUM_BALANCE) {
  return {
    jwo: {
      enabled,
      minimum_balance: minimumBalance,
    },
  };
}
